<div class="main-content">

  <div class="main-container">
    <div class="main-holder-box font-20">

      <h1 class="text-center primary-text mb-5">الشروط وسياسة الخصوصية</h1>

      <p class="text-indent text-justify mb-3">إن تطبيق My NTRA ("التطبيق") المملوك للجهاز القومي لتنظيم الاتصالات
        ("الجهاز") وما فيه من خدمات ومواقع أخرى متشعبة منه متاح لاستخدامك الشخصي، ويخضع دخولك واستخدامك لهذا التطبيق
        لشروط وقواعد الاستخدام وللأنظمة والقوانين المعمول بها في جمهورية مصر العربية وبالأخص قانون الاتصالات رقم 10 لسنة
        2003 وقانون مكافحة جرائم تقنية المعلومات 175 لسنة 2018، وكذلك يعد وصولك ودخولك إلى التطبيق وخدماته موافقة دون
        قيد أو شرط على شروط وقواعد الاستخدام، سواءً كنت مستخدماً مسجلاً أم لا، وتسري هذه الموافقة اعتباراً من تاريخ أول
        استخدام لك لهذا التطبيق.
        تنطبق قواعد استخدام تطبيق My NTRA للجهاز القومي لتنظيم الاتصالات على جميع زوار ومستخدمي التطبيق، ويجوز إيقاف
        و/أو منع و/أو إنهاء استخدام التطبيق في حال حدوث انتهاك من قبل أحد المستخدمين، أو في حال توفرت أسباب تدعو
        للاعتقاد بأن أحد المستخدمين قد انتهك وخالف شروط وقواعد الاستخدام.</p>

      <p class="text-indent text-justify mb-3">ويُحظر على المستخدمين انتهاك أو محاولة انتهاك الإجراءات والقواعد المعمول
        بها لحماية التطبيق، وعلى سبيل المثال، لا الحصر الأعمال التالية:</p>

      <div class="list-area text-justify mb-3">

        <ul>
          <li>الوصول إلى البيانات التي لا يقصد تقديمها لهذا المستخدم، أو الدخول على خادم أو حساب لا يصرح للمستخدم
            بالدخول عليه
          </li>
          <li>محاولة إجراء اختبار أو مسح أو فحص لإمكانية إصابة نقاط الضعف في نظام أو شبكة الجهاز أو انتهاك سلامة
            الإجراءات أو توثيقها دون تصريح رسمي من الجهاز.
          </li>
          <li>محاولة التدخل في الخدمة المقدمة لأي مستخدم أو مستضيف أو شبكة، بما في ذلك على سبيل المثال وليس الحصر، عن
            طريق وضع فيروس على التطبيق، أو زيادة الحمل عليه أو غمره، أو إرسال رسائل دعائية إليه، أو إغراقه بالرسائل
            الإلكترونية أو تعطيله.
          </li>
          <li>إرسال رسائل إلكترونية غير مرغوب فيها إلى التطبيق، بما في ذلك عمليات الدعاية، و/أو الإعلان عن المنتجات أو
            الخدمات؛ أو تزييف أي عنوان لحزمة بروتوكول التحكم في الإرسال / بروتوكول الإنترنت أو أي جزء من معلومات العنوان
            في أي رسالة إلكترونية أو إرسال رسائل مجموعات إخبارية.
          </li>
          <li>استخدام تطبيق الجهاز بأي طريقة كانت لإرسال بريد الكتروني أو أية أمور منه أو نيابة عنه أو من خلال الإشارة
            إليه أو بانتحال اسمه أو صفته تتضمن الإساءة أو التشهير بالجهاز، أو بالتطبيق أو بأي شخص كان، أو الإعلان عن
            أخبار أو معلومات غير صحيحة ونسبتها إلى الجهاز القومي لتنظيم الاتصالات بدون وجه حق.
          </li>
          <li>إن مخالفة قواعد الاستخدام وانتهاك النظام أو الشبكة يعرض المخالف للمسؤولية المدنية والجنائية. وسيتم مباشرة
            التحقيق في الحالات التي قد تنطوي على مثل هذه المخالفات والانتهاكات وملاحقة المتسبب فيها قضائياً.
          </li>
          <li>كل ما يعد مخالفة لقانون مكافحة الجرائم تقنية المعلومات رقم 175 لسنة 2018 أو أي قانون آخر ذو علاقة في
            جمهورية مصر العربية.
          </li>
        </ul>

      </div>


      <div class="mt-3 mb-5">
        <h3 class="primary-text content-right">كيفية استخدام الرابط الخاص بتطبيق My NTRA المملوك للجهاز القومي لتنظيم الاتصالات</h3>

        <p class="text-justify mr-4 mb-3">يمنع إنشاء أية روابط الكترونية خاصة بالتطبيق أو عرض أي منها في إطار أو وضع
          روابطه في أي موقع ما عدا وضع روابط خاصة بالخدمات في مواقع لا تتعارض في أهدافها وتوجهها العام مع أهداف وسياسات
          وأطر عمل الخدمات الإلكترونية التابعة للجهاز القومي لتنظيم الاتصالات.</p>

        <p class="text-justify mr-4 mb-3">لا يعتبر الجهاز بأي حال من الأحوال مشارك أو مرتبط بأي شكل كان بأي علامات أو
          شعارات أو رموز تجارية أو خدمية أو أية وسائل أخرى مستخدمة أو تظهر على بعض خدمات التطبيق أو أي من محتوياتها مالم
          تكن معتمدة لدى الإدارات المختصة لدى الجهاز.</p>

        <p class="text-justify mr-4 mb-3">يحتفظ الجهاز بكامل حقوقه في إيقاف وإعاقة أي ارتباط بأي شكل من الأشكال من أي
          موقع غير مصرح به أو يحتوي على مواضيع غير ملائمة أو فاضحة أو متعدية أو بذيئة أو إباحية أو غير لائقة أو غير
          مقبولة أو غير قانونية، أو أسماء أو مواد أو معلومات تخالف أي نظام أو تنتهك أية حقوق عامة أو خاصة.</p>

        <p class="text-justify mr-4 mb-3">لا يتحمل الجهاز أية مسئولية عن المحتويات المتوفرة في أي موقع آخر يتم الوصول
          إليه عبر هذا التطبيق أو الوصول من خلال خدمات الجهاز.</p>

      </div>

      <div class="mt-3 mb-5">
        <h3 class="primary-text content-right">حقوق الملكية</h3>

        <p class="text-justify mr-4 mb-3">تشرف الإدارة العامة للأنظمة المركزية بالجهاز على هذا التطبيق فنياً، وتعد جميع
          محتويات التطبيق من خدمات ومعلومات ملكًا للجهاز، وهي محمية بالكامل طبقا للقوانين المصرية لحقوق النشر والعلامات
          التجارية وحقوق الملكية الفكرية.</p>

        <p class="text-justify mr-4 mb-3">ما لم ينص على خلاف ذلك، لا يجوز بيع خدمات التطبيق ومواده أو ترخيصه أو تأجيره
          أو تعديله أو نسخه أو استنساخه أو إعادة طبعه أو الإعلان عنه أو نقله أو توزيعه أو عرضه بصورة علنية أو تحريره أو
          إنشاء أعمال مشتقة منه للجمهور أو لأغراض تجارية، دون الحصول على الموافقة المسبقة من الجهاز إلا للأغراض العلمية
          والبحثية ونشر الوعي فيجوز الاقتباس بشرط الإحالة إلى التطبيق.</p>
      </div>

      <div class="mt-3 mb-5">
        <h3 class="primary-text content-right">إنهاء الاستخدام</h3>

        <p class="text-justify mr-4 mb-3">يحق للجهاز وحسب تقديره المطلق إنهاء أو تقييد أو إيقاف حق المستخدم في الدخول
          إلى خدمات التطبيق واستخدامها دون إشعار ولأي سبب بما في ذلك مخالفة شروط وبنود الاستخدام أو أي سلوك آخر قد
          يعتبره الجهاز حسب تقديره غير قانوني أو مضرًا بالآخرين، وفي حالة الإنهاء، فإنه لن يكون مصرحا للمستخدم بالدخول
          و/أو التسجيل مرة آخرى في التطبيق.</p>
      </div>

      <div class="mt-3 mb-5">
        <h3 class="primary-text content-right">اشعار اخلاء المسؤولية</h3>

        <p class="text-justify mr-4 mb-3">الجهاز القومي لتنظيم الاتصالات غير مسؤول تحت أي ظرف من الظروف عن أي أضرار
          مباشرة أو غير مباشرة، عرضية أو ملحقة، خاصة أو استثنائية، ربما تنشأ عن استخدام، أو عدم القدرة على استخدام هذا
          التطبيق.</p>

        <p class="text-justify mr-4 mb-3">الخدمات الإلكترونية التي يقدمها التطبيق مشفرة بين طرفي الاتصال وتُقدم فقط
          لتسهيل الوصول للمعلومات الخاصة بالمستخدم، وبهذا يُقر المستخدم بعلمه الكامل بأن الاتصال عبر شبكة الإنترنت قد
          يتعرض للتدخل أو الاعتراض بواسطة الغير، وأن التطبيق وما فيه من خدمات لا يستبدل المعلومات المتوفرة من خلال
          الجهات الرسمية، وأن الطلبات والإجراءات الإدارية يمكن اتخاذها مباشرة أمام الجهات المختصة، وعليه؛ فإن اللجوء إلى
          هذا التطبيق يظل على مسؤولية المستخدم، ولا يكون الجهاز بأي حال من الأحوال مسؤول عن أي خسائر أو أضرار من أي نوع
          قد يتكبدها المستخدم، أو اعتماده على أي بيان أو رأي أو إعلان في التطبيق، أو ينجم عن أي تأخير في التشغيل، أو
          تعثر الاتصال، أو مشاكل الدخول إلى شبكة الإنترنت، أو أعطال المعدات، أو البرامج، أو سلوك أو أفكار أي شخص يدخل
          إلى هذا التطبيق، وبهذا يقر المستخدم هنا ويوافق على أن وسيلته الحصرية والوحيدة لعلاج أي ضرر أو خسارة قد تحدث
          نتيجة دخوله أو استخدامه لهذا التطبيق هي الامتناع عن استخدامه أو الدخول إليه أو عدم الاستمرار في ذلك.</p>
      </div>

      <div class="mt-3 mb-5">
        <h3 class="primary-text content-right">الحماية من الفيروسات</h3>

        <p class="text-justify mr-4 mb-3">يبذل الجهاز كافة الجهود لفحص واختبار محتويات التطبيق، وعلى المستخدم الالتزام
          بتشغيل برامج مضادات الفيروسات في جميع المواد التي يقوم بتنزيلها من التطبيق، ولا يكون للجهاز أدنى مسؤولية عن أي
          خسائر أو انقطاع أو تلفيات في بيانات وأجهزة المستخدم، عند استخدام التطبيق، أو المواد الواردة منها.</p>
      </div>

      <div class="mt-3 mb-5">
        <h3 class="primary-text content-right">التنازل عن المطالبات</h3>

        <p class="text-justify mr-4 mb-3">إن تطبيق الجهاز (“My NTRA”) والخدمات والمعلومات والمواد، أو التي يمكن الوصول
          إليها من خلاله تُوفر للمستخدم "كما هي" و"كما هي متاحة" دون أي إقرار أو وعود أو ضمانات من أي نوع ولا يمكن
          للجهاز أن يضمن أو يتحمل المسؤولية عن أي انقطاعات أو أخطاء أو تجاوزات قد تنشأ عن استخدام هذا التطبيق أو
          محتوياته أو أي موقع يرتبط به، سواء كان ذلك بعلمه أو بدون علمه.</p>

        <p class="text-justify mr-4 mb-3">لا يكون للمستخدم الحق في ملكية أي اتصالات أو معلومات قد يقوم بإرسالها من خلال
          خدمات هذا التطبيق أو حق ضمان سريتها كما أن أي استخدام أو استخدام تفاعلي تتضمنه هذه الخدمات لا تضمن للمستخدم أي
          حقوق أو تراخيص أو أية امتيازات من أي نوع.</p>
      </div>

      <div class="mt-3 mb-5">
        <h3 class="primary-text content-right">التعويض</h3>

        <p class="text-justify mr-4 mb-3">يقر المستخدم بعدم اتخاذ أي إجراءات ضد الجهاز أو موظفيه أو المسؤولين عن إدارة خدمات التطبيق أو صيانته أو تحديثه أو تقديمه، وإعفائه من جميع الالتزامات والمسؤوليات والتعويضات الناشئة عن استخدام الخدمات سواء كان الإخلال من جانبه ببنود وشروط الاستخدام، أو أي من الأنظمة السارية سواء في جمهورية مصر العربية أو المكان الذي يقيم فيه، أو لغير ذلك.</p>
      </div>

      <div class="mt-3 mb-5">
        <h3 class="primary-text content-right">التعديلات</h3>

        <p class="text-justify mr-4 mb-3">يحق للجهاز اجراء أي تعديل على الشروط والاحكام في أي وقتاً شاء.</p>

        <p class="text-justify mr-4 mb-3">يصبح أي تعديل لهذه الشروط والاحكام نافذاً فور إعلانه، ما لم يُبين خلاف ذلك، ويعني استمرارك في استخدام هذا التطبيق بعد إعلان أي تعديل قبول تام لذلك التعديل.</p>

        <p class="text-justify mr-4 mb-3">يمنع منعاً باتاً أي تعديل لأي من محتويات التطبيق بما فيها الرسومات والصور في هذا التطبيق حيث أنها محمية بموجب حقوق النشر، ولا يجوز استنساخها أو استغلالها بأية طريقة كانت، دون موافقة خطية مسبقة من الجهاز.</p>
      </div>

      <div class="mt-3 mb-5">
        <h3 class="primary-text content-right">اخلاء مسؤولية الروابط التشعبية الخارجية</h3>

        <p class="text-justify mr-4 mb-3">تم إدراج روابط لمواقع إلكترونية أخرى على هذا التطبيق، وذلك مراعاة لاحتياجات المستخدم، ولا يعتبر الجهاز القومي لتنظيم الاتصالات مسؤول عن أي محتويات موجودة على تلك المواقع الإلكترونية، ولا عن استخدام أي شخص لها أو عن عملها بشكل مناسب، أو عما قد ينشأ عن استخدامه من مشكلات.</p>

        <p class="text-justify mr-4 mb-3">ويكون المستخدم وحده مسؤولاً عن كافة ما يقوم به من تصرفات أثناء استخدامه أيّاً من المواقع الإلكترونية التي يقوم بزيارتها من خلال تلك الروابط الموجودة على هذا التطبيق.</p>
      </div>

      <div class="mt-3 mb-5">
        <h3 class="primary-text content-right">الروابط التشعبية من مواقع إلكترونية أخرى</h3>

        <p class="text-justify mr-4 mb-3">بهدف إتاحة المعلومات للجمهور بأوسع قدر ممكن، يسمح بالربط المباشر بكافة الصفحات التي تمت استضافتها على هذا التطبيق ومع ذلك، فإنه لا يسمح بتحميل أي صفحات داخل أطر منفصلة على موقع إلكتروني آخر.</p>
      </div>

      <div class="mt-3 mb-5">
        <h3 class="primary-text content-right">معايير التعليقات على متجر جوجل (Play Store) ومتجر أبل (App Store) والمشاركة الإلكترونية</h3>

        <p class="text-justify mr-4 mb-3">يجب على صاحب التعليق أن يلتزم بالآداب العامة وقوانين جمهورية مصر العربية، وأن يتجنب استخدام أية عبارات غير مناسبة أو ألفاظ خادشه للحياء في تعليقاته وتقييمه للتطبيق.</p>

        <p class="text-justify mr-4 mb-3">أن يكون التعليق منصباً على كيفية تحسين التطبيق وألا يبتعد عن ذلك بأي شكل من الأشكال عنه.</p>

        <p class="text-justify mr-4 mb-3">تجنب الوقوع في أية انتقادات شخصية لا تهدف إلى إثراء التطبيق.</p>
      </div>

      <div class="mt-3 mb-5">
        <h3 class="primary-text content-right">المرجع القضائي</h3>

        <p class="text-justify mr-4 mb-3">يخضع المستخدم للقوانين الاجرائية المعمول بها في جمهورية مصر العربية.</p>

        <p class="text-justify mr-4 mb-3">لجهاز الحق الكامل في مقاضاة أي شخص يخالف الشروط والأحكام واتخاذ كافة الإجراءات القانونية اللازمة ضده.</p>
      </div>

      <div class="mr-2 mt-5">
        <p class="lead content-right primary-text">
          يتم العمل به اعتبارًا من 1 سبتمبر 2021
        </p>

        <p class="lead content-right primary-text">
          تم التحديث فى 1 سبتمبر 2021
        </p>
      </div>


    </div>
  </div>

</div>

